import { Action } from '../../../redux/redux.types';
import { APPLICATIONS_UI_ACTION_NAMES } from './applications.actions';
import { ApplicationsUiState } from './applications.types';

const defaultState: ApplicationsUiState = {
  isCreateApplicationModalOpen: false,
};

export const applicationsUi = (
  state: ApplicationsUiState = defaultState,
  { type }: Action,
) => {
  switch (type) {
    case APPLICATIONS_UI_ACTION_NAMES.SHOW_CREATE_APPLICATION_MODAL: {
      return {
        isCreateApplicationModalOpen: true,
      };
    }

    case APPLICATIONS_UI_ACTION_NAMES.HIDE_CREATE_APPLICATION_MODAL: {
      return {
        isCreateApplicationModalOpen: false,
      };
    }

    default: {
      return state;
    }
  }
};
